import React from 'react'

const OurServiceCard = ({ service }) => {
    return (
<div className='col-md-4 mb-4' data-aos="zoom-in" style={{ cursor: 'pointer' }}>
            <article className='service_card_main d-md-flex p-3 rounded shadow' style={{ background: 'white', color: 'white', minHeight: '450px', transition: 'transform 0.3s ease' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                aria-label={service.title}
            >
                <div>
                    <div className='service_icon' style={{ fontSize: '2.5rem', backgroundColor: '#007bff', borderRadius: '50%', width: '50px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {service.icon}
                    </div>
                </div>
                <div className='ms-md-4 mt-md-0 mt-3' style={{ color: '#333' }}>
                    <h4 style={{ fontWeight: '700', fontSize: '1.25rem' }}>{service.title}</h4>
                    <div className="paragraph mb-0 mt-3" style={{ fontSize: '1rem', lineHeight: '1.5' }}>
                        {service.subtitle}
                    </div>
                </div>
            </article>
        </div>
    )
}

export default OurServiceCard
